/**
 * Just inserts google script on DOM.
 * This method should be called, preferably once, CLIENT SIDE (didMount)
 * at higher tree level, for example Page Level or App level.
 * @param {string} language
 */
const loadReCaptcha = (language = 'es', onload, onerror) => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://www.google.com/recaptcha/enterprise.js?${language ? `&hl=${language}` : ''}`
  if (onload) {
    script.onload = onload
  }
  if (onerror) {
    script.onerror = onerror
  }
  document.body.appendChild(script)
}

export default loadReCaptcha
